import React from 'react';
import PropTypes from 'prop-types';
import { getTitle} from '../../helpers/recorder.helpers';
import {ifGetErrorStatus } from '../../helpers/recorder.helpers';
//import { Link } from 'react-router-dom';
import './recorder-header.style.css';

const RecorderHeader = ({ status }) => (
  <div className="recorder-header">
    <span className="text-center">{getTitle(status)}</span>
    {ifGetErrorStatus(status) === true &&
        //do something if error is thrown when recording starts
        <span></span>
        //<Link to="/help"> Help</Link>
    }
  </div>
);

export default RecorderHeader;

RecorderHeader.propTypes = {
  status: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/messages/recorder/recorder-header/recorder-header.component.js